export const Roles = {
    PARENT_NAME: 'parent',
    STUDENT_NAME: 'student',
    RECRUITER_NAME: 'recruiter',
    COUNSELOR_NAME: 'counselor',
    ADMIN_NAME: 'admin',
    SCHOOL_IT_NAME: 'school_it'
}